// extracted by mini-css-extract-plugin
export default {"wrapper":"eNetsL","article":"fSWwln","componentMobile":"nZECfw","list":"wNFl6e","frameArticle":"oFdBF8","switcher":"mD2G6m"};